export default __webpack_public_path__ + "static/media/cape.9fd49283.png";